module.exports = __webpack_public_path__ + "img/TinyTAN_Sweet_Dreams_02.be251f43.png";